// extracted by mini-css-extract-plugin
module.exports = {"w175hke3":"w175hke3","lma5bw3":"lma5bw3"};